import { fetchApi } from "../fetchApi";

export async function fetchLimitedStocks({
  limit = 10,
  offset = 0,
  query = "",
}) {
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: { limit, offset, query },
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    headers: { "Content-Type": "application/json" },
  };

  const endpoint = "/mini-store/promotion/limited-stock";

  let response = await fetchApi({ requestOptions, endpoint });
  response = await JSON.parse(response);
  return response.result;
}
